<template>
  <div
    class="org-item"
    @click="projectList"
  >
    <i
      class="icon iconfont iconicon-test25"
      :class="{'founder': isFounder}"
    />
    <span class="org-name">
      {{ orgItemData.comname }}
    </span>
    <i
      v-if="isFounder"
      class="icon iconfont iconicon-test27"
      @click.prevent.stop="showActive"
    />
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  components: {
  },
  props: {
    orgItemData: {
      type: Object,
      default () {
        return {}
      }
    },
    mobile: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isShow: true,
      arrTitData: this.$isDingDing ? [
        {
          content: this.$t('message["1394"]')
        },
        {
          content: this.$t('message["1644"]')
        }
      ] : [
        {
          content: this.$t('message["1394"]')
        },
        {
          content: this.$t('message["1644"]')
        },
        {
          content: this.$t('message["520"]')
        }
      ]
    }
  },
  computed: {
    isFounder () {
      return this.orgItemData.isfounder * 1 === 1
    }
  },
  mounted () {
  },
  methods: {
    ...mapMutations('organization/org', ['setAdmin', 'setFounder']),
    ...mapMutations(['setPid']),
    projectList () {
      this.setPid('')
      this.$router.push({
        name: 'ProjectIndexPc',
        query: {
          cid: this.orgItemData.cid
        }
      })
    },
    showActive () {
      this.$createActionSheet({
        title: '',
        active: 0,
        data: this.arrTitData,
        onSelect: (item, index) => {
          // this.$createToast({
          //   txt: `Clicked ${item.content}`,
          //   type: 'correct',
          //   time: 1000
          // }).show()
          if (index === 0) {
            this.$router.push({
              name: 'OrgIndex',
              query: {
                page: 4,
                cid: this.orgItemData.cid,
                comname: this.orgItemData.comname
              } })
          } else if (index === 2) {
            this.$router.push({
              name: 'OrgIndex',
              query: {
                page: 7,
                cid: this.orgItemData.cid,
                comname: this.orgItemData.comname,
                mobile: !this.$isDingDing ? this.mobile : ''
              } })
          } else if (index === 1) {
            this.$router.push({
              name: 'OrgIndex',
              query: {
                page: !this.$isDingDing ? 8 : 9,
                cid: this.orgItemData.cid,
                comname: this.orgItemData.comname,
                mobile: !this.$isDingDing ? this.mobile : ''
              } })
          }
        },
        onCancel: () => {
          // this.$createToast({
          //   txt: `Clicked canceled`,
          //   type: 'warn',
          //   time: 1000
          // }).show()
        }
      }).show()
    }
  }
}
</script>
